<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon" :title="$t('general.back')" @click.prevent="backButton"><i class="ti-arrow-left"></i></a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="$route.params.id" @click.prevent="deleteOrderScreen" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-6 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>ID</label>
                  <input type="number"
                    disabled
                    placeholder="ID"
                    v-model="model.id"
                    class="form-control">
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.firstname')}}</label>
                  <input type="text"
                    placeholder="Firstname"
                    v-validate="modelValidate.firstname"
                    v-model="model.firstname"
                    class="form-control">
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.lastname')}}</label>
                  <input type="text"
                    placeholder="Lastname"
                    v-validate="modelValidate.lastname"
                    v-model="model.lastname"
                    class="form-control">
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.email')}}</label>
                  <input type="text"
                    placeholder="Email"
                    v-validate="modelValidate.email"
                    v-model="model.email"
                    class="form-control">
                </div>
                <div
                  class="form-group pos-user-location-group"
                  :class="{'has-error': errors.has('location_details')}">
                  <label>{{$t('settingTable.location')}}</label>
                  <el-select
                    v-model="model.location_details"
                    multiple
                    filterable
                    default-first-option
                    style="width: 100%; color: #fff;"
                    :placeholder="$t('general.add')"
                    @change="onLocationDetailsChange"
                  >
                    <el-option
                      v-for="item in locations"
                      :key="item.id"
                      :value="item.id"
                      :label="item.name"
                    />
                  </el-select>
                  <!-- <small class="text-danger" v-if="errors.has('location_details')">
                    {{ errors.first('location_details') }}
                  </small> -->
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.login_code')}}</label>
                  <input type="number"
                    placeholder="Login Code"
                    v-validate="modelValidate.login_code"
                    v-model="model.login_code"
                    class="form-control">
                    <small class="text-danger" v-if="errors.has('login_code')">
                      {{ $t('settingTable.login_code_already_used') }}
                    </small>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.allow_maps')}}</label>
                  <div class="form-group">
                    <el-select
                      key="methods"
                      name="methods"
                      v-model="model.allow_maps"
                      multiple
                      filterable
                      default-first-option
                      style="width: 100%; color: #fff;"
                      :placeholder="$t('general.add')">
                      <el-option
                        :value="null"
                        :label="$t('general.all')"
                        :key="0" disabled>
                      </el-option>
                      <template v-for="item in tableMaps">
                            <el-option
                              :value="item.id"
                              :label="item.name">
                            </el-option>
                      </template>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content" style="height:100%; width:100%; margin: 0; display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: center;">

            <div class="form-group">
              <label>{{$t('settingLocationGroups.active')}}</label>
              <p-switch v-model="model.active" type="success"></p-switch>
            </div>
            <div>
              <label>{{$t('settingTable.is_manager')}}</label>
              <p-switch v-model="is_manager" type="success" ></p-switch>
            </div>
            <div class="isManagerBox">
              <div class="managerBox" v-if="is_manager">
                <div class="form-group">
                  <label>{{$t('settingTable.pos_allow_advanced_settings')}}</label>
                  <p-switch v-model="model.pos_allow_advanced_settings" type="success" ></p-switch>
                  <small class="text-muted" style="display: block;">{{$t('settingTable.pos_allow_advanced_settings_info')}}</small>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.pos_allow_access_reports')}}</label>
                  <p-switch v-model="model.pos_allow_access_reports" type="success" ></p-switch>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.pos_allow_reports')}}</label>
                  <p-switch v-model="model.pos_allow_reports" type="success" ></p-switch>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.pos_allow_approvals')}}</label>
                  <p-switch v-model="model.pos_allow_approvals" type="success" ></p-switch>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.pos_allow_discount')}}</label>
                  <p-switch v-model="model.pos_allow_discount" type="success" ></p-switch>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.pos_allow_storno')}}</label>
                  <p-switch v-model="model.pos_allow_storno" type="success" ></p-switch>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.pos_allow_refund')}}</label>
                  <p-switch v-model="model.pos_allow_refund" type="success" ></p-switch>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.allow_access_all_tables')}}</label>
                  <p-switch v-model="model.allow_access_all_tables" type="success" ></p-switch>
                </div>
                <div>
                  <label>{{$t('settingTable.pos_allow_transfer')}}</label>
                  <p-switch v-model="allow_transfer" type="success" ></p-switch>
                </div>
                <div class="isManagerBox">
                  <div class="managerBox" v-if="allow_transfer">
                    <div class="form-group">
                      <label>{{$t('settingTable.pos_allow_waiter_transfer')}}</label>
                      <p-switch v-model="model.pos_allow_waiter_transfer" type="success" ></p-switch>
                    </div>
                    <div class="form-group">
                      <label>{{$t('settingTable.pos_allow_table_transfer')}}</label>
                      <p-switch v-model="model.pos_allow_table_transfer" type="success" ></p-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.pos_allow_order_change_status')}}</label>
              <p-switch v-model="model.pos_allow_order_change_status" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.table_for_one_user')}}</label>
              <p-switch v-model="model.table_for_one_user" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.pos_allow_mobile_pos')}}</label>
              <p-switch v-model="model.pos_allow_mobile_pos" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.pos_allow_plata_moderna')}}</label>
              <p-switch v-model="model.pos_allow_plata_moderna" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.pos_allow_protocol')}}</label>
              <p-switch v-model="model.pos_allow_protocol" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.pos_allow_glovo')}}</label>
              <p-switch v-model="model.pos_allow_glovo" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.pos_allow_bolt')}}</label>
              <p-switch v-model="model.pos_allow_bolt" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.pos_allow_wolt')}}</label>
              <p-switch v-model="model.pos_allow_wolt" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.pos_allow_tips')}}</label>
              <p-switch v-model="model.pos_allow_tips" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.pos_disable_cancel_order')}}</label>
              <p-switch v-model="model.pos_disable_cancel_order" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.allow_close_order_without_receipt')}}</label>
              <p-switch v-model="model.allow_close_order_without_receipt" type="success"></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.allow_bank_transfer')}}</label>
              <p-switch v-model="model.pos_allow_bank_transfer" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.pos_allow_staff_food')}}</label>
              <p-switch v-model="model.pos_allow_staff_food" type="success" ></p-switch>
            </div>
            <div class="form-group">
              <label>{{$t('settingTable.allow_some_top_categories')}}</label>
              <p-switch v-model="model.allow_some_top_categories" type="success" ></p-switch>
              <div class="form-group" v-if="model.allow_some_top_categories">
                <el-select
                  key="methods"
                  name="methods"
                  v-model="model.allowed_top_categories"
                  multiple
                  filterable
                  default-first-option
                  style="width: 100%; color: #fff;"
                  :placeholder="$t('general.add')">
                  <el-option
                    :value="null"
                    :label="$t('general.none')"
                    :key="0" disabled>
                  </el-option>
                  <template v-for="item in topCategories">
                        <el-option
                          :value="item.id"
                          :label="item.name">
                        </el-option>
                  </template>
                </el-select>
              </div>
            </div>

            <div class="form-group">
              <label>{{$t('settingTable.pos_filter_status_orders ')}}</label>
              <el-select
                key="methods"
                name="methods"
                v-model="model.pos_filter_status_orders "
                multiple
                filterable
                default-first-option
                style="width: 100%; color: #fff;"
                :placeholder="$t('general.add')"
                >
                <el-option
                  :value="null"
                  :label="$t('general.none')"
                  :key="0" disabled>
                </el-option>
                <template v-for="item in allStatusesForFilterOrders">
                      <el-option
                        :value="item.name"
                        :label="item.name">
                      </el-option>
                </template>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      PSwitch,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.getData()
    },
    watch: {
      is_manager (newVal) {
        this.onChangeManager(newVal)
      },
      allow_transfer (newVal) {
        this.onChangeAllowTransfer(newVal)
      }
    },
    data () {
      return {
        id: this.value || this.tableId,
        locations: [],
        tableMaps: [],
        is_manager: false,
        is_manager_first: true,
        allow_transfer: false,
        allow_transfer_first: true,
        model: {
          'id': 0,
          'role': 'POS',
          'language': 'en',
          'loyalty_points': 0,
          'has_push_notifications': 0,
          'has_email_notifications': 0,
          'is_verified': 0,
          'is_created_from_admin': 0,
          'is_siteadmin': 0,
          'firstname': null,
          'lastname': null,
          'login_code': null,
          'active': true,
          'pos_allow_discount': false,
          'pos_allow_storno': false,
          'pos_allow_refund': false,
          'table_for_one_user': false,
          'pos_allow_order_change_status': true,
          'pos_allow_reports': false,
          'pos_allow_approvals': false,
          'pos_allow_access_reports': false,
          'pos_allow_waiter_transfer': false,
          'pos_allow_table_transfer': false,
          'allow_close_order_without_receipt': false,
          'allow_access_all_tables': false,
          'pos_allow_advanced_settings': false
        },
        allStatusesForFilterOrders: [
          { id: 'NEW', name: 'NEW' },
          { id: 'ON_HOLD', name: 'ON_HOLD' },
          { id: 'POSTPONED', name: 'POSTPONED' },
          { id: 'PROCESSING', name: 'PROCESSING' },
          { id: 'PREPARED', name: 'PREPARED' },
          { id: 'TRANSPORT', name: 'TRANSPORT' },
          { id: 'DELIVERED', name: 'DELIVERED' },
          { id: 'CANCELED', name: 'CANCELED' }
        ],
        modelValidate: {
          firstname: {required: true},
          lastname: {required: true},
          email: {required: true, email: true},
          login_code: {
            required: true,
            regex: /^[0-9]{4}$/
          }
        },
        topCategories: null,
        loading: true
      }
    },
    methods: {
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy)
      },
      getData () {
        var id = this.id || this.route.params.id
        if (id) {
          let data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/pos/user/' + id, 'GET', data, (response) => {
            if (response.status) {
              this.model = response.data.pos_user
              this.model.active = this.model.active === undefined || this.model.active === null
                ? true
                : !!(+this.model.active || this.model.active === true)

              const hasManagerFlags =
                  this.model.pos_allow_access_reports ||
                  this.model.pos_allow_reports ||
                  this.model.pos_allow_approvals ||
                  this.model.pos_allow_discount ||
                  this.model.pos_allow_refund ||
                  this.model.pos_allow_storno ||
                  this.model.allow_access_all_tables ||
                  this.model.pos_allow_waiter_transfer ||
                  this.model.pos_allow_table_transfer ||
                  this.model.pos_allow_advanced_settings

              if (hasManagerFlags) {
                this.is_manager_first = false
                this.is_manager = true
              }

              if (
                  this.model.pos_allow_waiter_transfer ||
                  this.model.pos_allow_table_transfer
                  ) {
                this.allow_transfer_first = false
                this.allow_transfer = true
              }
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }

        this.locations = []
        let requestData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-locations', 'GET', requestData, (response) => {
          if (response.status) {
            this.locations = response.data
          }
        })

        var data2 = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/topcategory', 'GET', data2, (topCatResp) => {
          if (topCatResp.status === true) {
            this.topCategories = topCatResp.data
          }
        })

        this.getTableMaps()
      },
      getTableMaps () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/pos/all/map', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableMaps = response.data.table_maps
          }
        })
      },
      onChangeManager (newVal) {
        if (this.is_manager_first) {
          if (this.is_manager) {
            this.model.pos_allow_discount = true
            this.model.pos_allow_refund = true
            this.model.pos_allow_reports = true
            this.model.pos_allow_access_reports = true
            this.model.pos_allow_approvals = true
            this.model.pos_allow_storno = true
            this.model.allow_access_all_tables = true
            this.allow_transfer = true
            this.model.pos_allow_waiter_transfer = true
            this.model.pos_allow_table_transfer = true
          } else {
            this.model.pos_allow_discount = false
            this.model.pos_allow_storno = false
            this.model.pos_allow_refund = false
            this.model.pos_allow_reports = false
            this.model.pos_allow_access_reports = false
            this.model.pos_allow_approvals = false
            this.model.allow_access_all_tables = false
            this.allow_transfer = false
            this.model.pos_allow_transfer = false
            this.model.pos_allow_waiter_transfer = false
            this.model.pos_allow_table_transfer = false
            this.model.pos_allow_advanced_settings = false
          }
        }
        this.is_manager_first = true
      },
      onChangeAllowTransfer (newVal) {
        if (this.allow_transfer_first) {
          if (this.allow_transfer) {
            this.model.pos_allow_waiter_transfer = true
            this.model.pos_allow_table_transfer = true
          } else {
            this.model.pos_allow_waiter_transfer = false
            this.model.pos_allow_table_transfer = false
          }
        }
        this.allow_transfer_first = true
      },
      onLocationDetailsChange () {
        const loc = this.model.location_details
        const ok = Array.isArray(loc) && loc.length > 0
        if (ok) {
          this.errors.remove('location_details')
        } else {
          this.errors.remove('location_details')
          this.errors.add('location_details', this.$t('validations.requiredField'))
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          const loc = this.model.location_details
          const hasLocs = Array.isArray(loc) && loc.length > 0
          if (!hasLocs) {
            this.errors.remove('location_details')
            this.errors.add('location_details', this.$t('validations.requiredField'))
          } else {
            this.errors.remove('location_details')
          }
          if (isValid && hasLocs) {
            this.saveTable()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      saveTable () {
        this.loading = true
        this.model.login_code = this.model.login_code
        let data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany'),
          'pos_user': this.model
        }

        var id = this.id || this.route.params.id
        let url = ''
        let request = ''
        if (id) {
          url = '/pos/user/' + id
          request = 'PUT'
        } else {
          url = '/pos/user/add'
          request = 'POST'
        }
        this.apiRequest(url, request, data, (response) => {
          if (response.status === true) {
            this.errors.clear()
            if (request === 'POST') {
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
              // this.router.push('/pos/users/' + response.data.pos_user.id)
            } else {
              this.backButton()
            }
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
          } else {
            this.handleErrors(response.errors)
          }
          this.loading = false
        })
      },
      deleteOrderScreen () {
        this.loadingReset = true
        var id = this.id || this.route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/pos/user/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.backButton()
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
          this.loadingReset = false
        })
      },
      backButton () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
        // this.router.push('/pos/tabs?tabIndex=2')
      }
    }
  }

</script>
<style scoped lang="scss">
  .isManagerBox {
    margin-bottom: 20px;
    .managerBox {
      padding: 20px;
      border: 1px solid #ddd;
    }
  }
</style>
<style>
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  span.el-select__tags-text {
    color: #fff;
  }
  /* Match .has-error .form-control (paper _inputs.scss: $danger-input-bg / $danger-color) */
  .pos-user-location-group.has-error .el-input__inner {
    background-color: #FFC0A4 !important;
    color: #EA7867 !important;
    border-color: #EA7867 !important;
  }
  .pos-user-location-group.has-error .el-input.is-focus .el-input__inner,
  .pos-user-location-group.has-error .el-input__inner:focus {
    background-color: #FFFFFF !important;
    border-color: #EA7867 !important;
    color: #333333 !important;
  }
  .pos-user-location-group.has-error span.el-select__tags-text {
    color: #EA7867 !important;
  }
  .pos-user-location-group.has-error .el-input.is-focus span.el-select__tags-text {
    color: #333333 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/users/PosUserForm.vue